import service from "@/service/service";

export const publicConf = () => service.get("/public/conf");
